import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFound() {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/");
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f9fbfd",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Header activeTab="" onTabChange={() => {}} onLogout={() => {}} />

            <Container
                maxWidth="xl"
                sx={{
                    flexGrow: 1,
                    py: 4,
                    px: { xs: 2, md: 4 },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 3,
                        maxWidth: 600,
                    }}
                >
                    <ErrorOutlineIcon
                        sx={{
                            fontSize: 120,
                            color: "#e0e0e0",
                        }}
                    />

                    <Typography
                        variant="h1"
                        component="h1"
                        sx={{
                            color: "#333",
                            fontWeight: 700,
                            fontSize: { xs: "4rem", md: "6rem" },
                            lineHeight: 1,
                        }}
                    >
                        404
                    </Typography>

                    <Typography
                        variant="h4"
                        component="h2"
                        sx={{
                            color: "#333",
                            fontWeight: 500,
                            mb: 2,
                            fontSize: { xs: "1.5rem", md: "2rem" },
                        }}
                    >
                        Page Not Found
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: "#666",
                            fontSize: { xs: "1rem", md: "1.1rem" },
                            lineHeight: 1.6,
                            mb: 4,
                        }}
                    >
                        Sorry, the page you are looking for doesn't exist or has been moved.
                        Please check the URL or navigate back to the homepage.
                    </Typography>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            flexDirection: { xs: "column", sm: "row" },
                            width: { xs: "100%", sm: "auto" },
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={handleGoHome}
                            sx={{
                                bgcolor: "#1976d2",
                                color: "white",
                                px: 4,
                                py: 1.5,
                                fontSize: "1rem",
                                textTransform: "none",
                                "&:hover": {
                                    bgcolor: "#1565c0",
                                },
                            }}
                        >
                            Go to Dashboard
                        </Button>

                        <Button
                            variant="outlined"
                            onClick={handleGoBack}
                            sx={{
                                borderColor: "#1976d2",
                                color: "#1976d2",
                                px: 4,
                                py: 1.5,
                                fontSize: "1rem",
                                textTransform: "none",
                                "&:hover": {
                                    borderColor: "#1565c0",
                                    color: "#1565c0",
                                    bgcolor: "rgba(25, 118, 210, 0.04)",
                                },
                            }}
                        >
                            Go Back
                        </Button>
                    </Box>
                </Box>
            </Container>

            <Footer />
        </Box>
    );
}